import { PackedTexture } from './types.ts';

/**
 * Render packed texture pages to ImageBitmaps.
 * Equivalent to the server's renderTexture() in zipService.ts.
 */
export async function renderAtlasPages(packedTextures: PackedTexture[]): Promise<ImageBitmap[]> {
  return Promise.all(packedTextures.map(async pt => {
    const canvas = new OffscreenCanvas(pt.width, pt.height);
    const ctx = canvas.getContext('2d')!;
    for (const pf of pt.frames) {
      ctx.drawImage(pf.frame.bitmap, pf.x, pf.y);
    }
    return canvas.transferToImageBitmap();
  }));
}
